import { useLocation } from "react-router-dom";

import {
  ALERT_COLOR_KEY,
  ALERT_DISCLAIMER_KEY,
  ALERT_MESSAGE_KEY,
  ALERT_TITLE_KEY,
  type AlertState,
} from "./constants";

type LocationState = {
  state?: AlertState;
};

export function useRequestDetailsAlert(): AlertState {
  const { state }: LocationState = useLocation();

  return {
    alertTitle: state?.[ALERT_TITLE_KEY],
    alertMessage: state?.[ALERT_MESSAGE_KEY],
    alertDisclaimer: state?.[ALERT_DISCLAIMER_KEY],
    alertColor: state?.[ALERT_COLOR_KEY] as AlertState["alertColor"],
  };
}
